<button mat-menu-item
  class="edit-activity-btn"
  data-cy="activity-options-edit-activity"
  (click)="editActivity()">
  <span translate="activity-list_activity-options-menu-edit-activity"></span>
</button>
@if (canDuplicateActivity()) {
  <button mat-menu-item
    class="duplicate-activity-btn"
    data-cy="activity-options-duplicate-activity"
    (click)="duplicateActivity()">
    <span translate="activity-list_activity-options-menu-duplicate-activity"></span>
  </button>
}
@if (canAddToLibrary()) {
  <button mat-menu-item
    data-cy="copy-to-library"
    class="copy-to-library-btn"
    (click)="addToLibrary()">
    <span translate="activity-list_activity-options-menu-copy-to-library"></span>
  </button>
}
<button mat-menu-item
  data-cy="activity-options-view-report-activity"
  class="view-assignment-report-btn"
  (click)="openActivityReport()">
  <span translate="activity-list_activity-options-menu-view-report"></span>
</button>
@if (shouldShowInstructorRubricReportButton()) {
  <button mat-menu-item
    class="view-instructor-rubric-report-btn"
    (click)="downloadActivityRubricReport('instructor')">
    <span translate="activity-list_activity-options-menu-instructor-rubric-report"></span>
  </button>
}
@if (shouldShowStudentRubricReportButton()) {
  <button mat-menu-item
    class="view-student-rubric-report-btn"
    (click)="downloadActivityRubricReport('student')">
    <span translate="activity-list_activity-options-menu-student-rubric-report"></span>
  </button>
}
@if (!limitActivityOption) {
  <button mat-menu-item
    data-cy="activity-options-delete-activity"
    class="archive-activity-btn"
    (click)="archiveActivity()">
    <span translate="activity-list_activity-options-menu-archive-activity"></span>
  </button>
}

@if (shouldShowFeedbackHold() || (isMobile$ | async)) {
  <mat-divider class="is-mobile"></mat-divider>
}

@if (shouldShowFeedbackHold()) {
  <span class="is-mobile feedback-hold" mat-menu-item>
    <feedback-hold></feedback-hold>
  </span>
}

@if (isMobile$ | async) {
  <span mat-menu-item>
    <activity-task-toggle></activity-task-toggle>
  </span>
}
